/*
 * ProcessUser.tsx
 * Author: fwunderlich
 * Date: 10.04.2024
 *
 * Copyright: DMT GmbH & Co. KG
 */

import React, {useEffect, useState} from 'react';
import {useGetUsersQuery} from '../../../redux/rtk/injectedSystemApi';
import Input from '../../global/Input';
import {useTranslation} from 'react-i18next';
import {faPhone, faEnvelope} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {showMessageOnSuccess} from '../../global/CustomToast';

type Props = {
    projectId: any,
    id: string,
    type: string,
}

export const ProcessUser = (props: Props): JSX.Element => {

    const {t} = useTranslation(['common', 'globalData']);

    const [userList, setUserList] = useState<any[]>([]);

    const users = useGetUsersQuery({projectId: props.projectId, mapping: {[props.type]: props.id}});

    useEffect(() => {
        console.log('user data', users.data);
        if (users.data) {
            console.log(users.data);
            let temp: any[] = [];

            let addedRoles: string[] = [];
            // temp.push({name: name, user: item});

            for (let i = 0; i < users.data.length; i++) {
                let user = users.data[i];
                if (addedRoles.indexOf(user.role_name) < 0) {
                    addedRoles.push(user.role_name);
                    temp.push({name: user.role_name, users: [user]});
                } else {
                    let found = temp.find((item: any) => {
                        return item.name === user.role_name;
                    });
                    if (found) {
                        found.users.push(user);
                    }
                }
            }

            console.log(temp);
            setUserList(temp);
        }
    }, [users]);

    const getComponent = (item: any) => {
        if (item && item.users) {
            let first = [];
            let addition = [];

            for (let i = 0; i < item.users.length; i++) {
                let user = item.users[i];

                let content = <><FontAwesomeIcon
                    className="mx-2" icon={faPhone}
                    style={{marginBottom: '1px'}}
                    onClick={() => {
                        showMessageOnSuccess(t('dialogs.addedToClipboard'), user.sms, 1500);
                    }}
                />
                    <a style={{color: 'var(--primary)'}} href={'mailto:' + user.email}><FontAwesomeIcon
                        className="mx-2" icon={faEnvelope}/></a>
                    {user.last_name + ', ' + user.first_name}</>;

                if (user.ist_haupt_bearbeiter) {
                    first.push(<div style={{textDecoration: 'underline'}}
                                    className={'ml-2'}>{item.name.charAt(0).toUpperCase() + ': '}
                        {content}
                    </div>);
                } else {
                    addition.push(<div className={'ml-2'}>
                        {content}
                    </div>);
                }
            }

            return <div>
                <div className={'process-user-hauptrolle'}>{first}</div>
                <div className={'process-user-addition'}>{addition}</div>
            </div>;
        }
    };

    return (
        <div className={'grid grid-nogutter relative'} style={{cursor: 'pointer', fontSize: '1rem', fontWeight: '400'}}>
            {userList.map((item, index) => {
                return <div className={'col-auto relative'}>
                    <div className={'flex ml-2 process-user'}>{getComponent(item)}</div>
                </div>;
            })}
        </div>
    );
};
